<!-- <p>
  manage-auction-fees works!
</p> -->

<div style="display:flex">
  <p-breadcrumb [model]="crumbs" styleClass="breadCrumbClass">
  </p-breadcrumb>
  <p-toast position="top-right" styleClass="manage-bid-toast">
      <ng-template let-message pTemplate="message">
          <div style="text-align: center; display: flex;">
              <i class="pi pi-exclamation-triangle toast-icon" style="font-size: 2em"></i>&nbsp;
              <p class="toast-message">{{message.detail}}</p>
          </div>
      </ng-template>
  </p-toast>&nbsp;&nbsp;

  <button pButton type="button" 
      label="Add Auction Fees" 
      *ngIf="action.listAuctionFees" 
      class="ui-button-secondary" 
      (click)="displayAddAuctionFeesForm()"></button>&nbsp;&nbsp;

  <button pButton type="button" 
      label="Change Log"
      *ngIf="action.listAuctionFees"
      class="ui-button-secondary" 
      (click)="showChangeLogDialog()"></button>&nbsp;&nbsp;
</div>

<div *ngIf="action.listAuctionFees">
  <app-list-auction-fees
      (doeditBidInstructionEvent)="displayEditAuctionFeesForm()" 
      (selectedAuctionFees)="setSelectedAuctionFees($event)"
      (setBreadCrumbs)="setBreadCrumbs($event)"
      (objMessage)="showMessage($event)">  
  </app-list-auction-fees>
</div>

<!--- /// Add Bid Instruction /// --->
<div *ngIf="action.addAuctionFees">
    <app-add-auction-fees
        (cancelAddEvent)="hideAddAuctionFeesForm()" 
        (setBreadCrumbs)="setBreadCrumbs($event)"
        (objMessage)="showMessage($event)">
    </app-add-auction-fees>
</div>

<div *ngIf="action.editAuctionFees">
    <app-edit-auction-fees
        (cancelEditEvent)="hideEditAuctionFeesForm($event)" 
        (setBreadCrumbs)="setBreadCrumbs($event)" 
        (objMessage)="showMessage($event)"
        [currentRecord]="selectedAuctionFees">
    </app-edit-auction-fees>
</div>

<div *ngIf="display">
    <app-change-log-auction-fees
        [showDialog]="display"
        (closeDialog)="closeDialog($event)">
    </app-change-log-auction-fees>
</div>
